import { ReactNode } from 'react';

import { AllUnionMemberKeys } from 'types/utils';

const MENU_SECTIONS = {
  RESOURCES: 'resources',
  HELP: 'help',
  APP_DOWNLOAD: 'app-download',
} as const;

const SECTION_VARIANT = {
  LIST: 'list',
  GRID: 'grid',
} as const;

interface Classnames {
  root: string;
  option: string;
  label?: string;
  arrow?: string;
}

interface MenuSection {
  variant?: AllUnionMemberKeys<typeof SECTION_VARIANT>;
  section: AllUnionMemberKeys<typeof MENU_SECTIONS>;
  onMenuClick?: (key?: string) => void;
  classnames: Partial<Classnames>;
}

interface Menu {
  id: string;
  link: string;
  label?: string;
  children?: JSX.Element;
  icon?: ReactNode;
  target: string;
  rel: string;
  key: string;
  hide?: boolean;
  containerClass?: string;
}

export { MENU_SECTIONS, SECTION_VARIANT };

export type { Menu, MenuSection };
